<template>
  <div class="maximizeAndCenter">
    <transition name="fade" mode="out-in">
      <component
        v-bind:is="component"
        @changeToProgrammingMode="changeToProgrammingMode"
        @submitSuccess="switchComponents"
      />
    </transition>
  </div>
</template>

<script>
import Authenticate from "@/components/Authenticate.vue";
import Otp from "@/components/Otp.vue";
import Video from "@/components/Video.vue";
export default {
  name: "Form",
  components: {
    Authenticate,
    Otp,
    Video,
  },
  data() {
    return {
      component: Authenticate,
    };
  },
  methods: {
    switchComponents() {
      if (this.component === Authenticate) {
        this.component = Otp;
      } else if (this.component === Otp) {
        this.component = Video;
      }
    },

    changeToProgrammingMode() {
      this.$emit("changeToProgrammingMode");
    },
  },
};
</script>
